import BeneficiaryList from '../moneyTransfer/LegacyBeneficiaryList';
import { DMT_OPERATOR_CONFIGS, DMT_OPERATOR } from '../moneyTransfer/dmtOperatorConfigs';

export default function FinoBeneficiaryList(props) {
    return (
        <BeneficiaryList
            {...props}
            config={DMT_OPERATOR_CONFIGS[DMT_OPERATOR.FINO]}
        />
    );
}


// import { Button, Modal, Radio, Checkbox } from 'antd';
// import { LoadingOutlined } from '@ant-design/icons';
// import PropagateLoader from "react-spinners/PropagateLoader";
// import DataTable from 'react-data-table-component';
// import 'antd/dist/antd.css';
// import { useHistory } from "react-router-dom";
// import { CheckOutlined, CloseOutlined, PlusOutlined, SyncOutlined, ArrowLeftOutlined } from '@ant-design/icons';
// import { ToastContainer, toast } from 'react-toastify';
// import { isNumber, isAlphabetOnly, getUser } from '../../Utils/Common';
// import { postRequest, getRequest } from '../../Utils/AppApi';
// import {
//     FINO_IMW_GET_BENEFICIARY_LIST,
//     FINO_IMW_ADD_BENEFICIARY,
//     POST_DMT_PAY_SPRINT_CONFIRM_INITIATE_TRANSACTION,
//     FINO_IMW_INITIATE,
//     FINO_IMW_GENERATE,
//     FINO_IMW_PAYMENT_TRANSFER,
//     GET_DMT_NEW_BANK_LIST,
//     IFSC_CODE_VERIFY,
//     GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER,
//     POST_DMT_FAILED_BY_PARTNER,
//     UPDATE_DMT_JIO_BENEFICIARY_STATUS,
//     UPDATE_DMT_JIO_BENEFICIARY_DETAIL
// } from '../../Utils/appConstants';
// import FinoInvoice from './finoInvoice';
// import Select from 'react-select';
// import { refId, isIfscCodeValid } from './../../Utils/function';
// import ImportBaneficiary from '../moneyTransfer/import';
// // ----- Theme -----
// const primaryRed = '#C9262C';
// const primaryOrange = '#FF8C00';
// const primaryGreen = '#02A650';
// const cardBorder = '#E5E7EB';
// const lightBg = '#F9FAFB';

// // ----- Font size helper: increase by 25% (multiply by 1.25) -----
// const fs = (size) => `${size * 1.25}px`;

// // ----- Consistent input style (height: 48px) -----
// const inputStyle = {
//     height: '48px',
//     borderRadius: '10px',
//     border: `1px solid ${cardBorder}`,
//     padding: '0 16px',
//     fontSize: fs(15),
//     transition: 'border 0.3s, box-shadow 0.3s',
//     width: '100%',
//     outline: 'none',
//     background: '#fff',
// };

// const inputFocusStyle = {
//     borderColor: primaryRed,
//     boxShadow: `0 0 0 3px rgba(201,38,44,0.12)`,
// };

// // ----- Main Component -----
// function BeneficiaryList({ customerData, findCustomerInfo }) {
//     const history = useHistory();
//     const limit = 10;
//     const [getData, setData] = useState([]);
//     const [isLimit, setLimit] = useState(limit);
//     const [page, setPage] = useState(1);
//     const customerMobile = customerData?.customerMobile;
//     const [saveCustomerMobile, setCustomerMobile] = useState(customerMobile);
//     const [isLoading, setLoading] = useState(false);
//     const [searchText, setSearchText] = useState(null);
//     const [timer, setTimer] = useState(null);
//     const [latitude, setLatitude] = useState("");
//     const [longitude, setLongitude] = useState("");

//     // ----- Available limit from customerData (Fino uses 'remaining') -----
//     const availableLimit = customerData?.remaining || customerData?.limit || 0;

//     // ----- View Mode: 'list', 'add', 'send', 'otp', 'otpBatch' -----
//     const [view, setView] = useState('list');

//     // ----- Add Beneficiary State -----
//     const [getBeneData, setBeneData] = useState({});
//     const [getBeneError, setBeneError] = useState({});
//     const [bankId, setBankId] = useState(null);
//     const [getBankListData, setBankListData] = useState([{ value: '', label: '-- Select Bank --' }]);
//     const [getEKOBankListData, setEKOBankListData] = useState([]);
//     const [selectedOption, setSelectedOption] = useState(null);
//     const [isIfscEnable, setIfscEnable] = useState(false);
//     const [getDataField, setDataField] = useState({});

//     // ----- Send Money State -----
//     const [selectedSendRow, setSelectedSendRow] = useState(null);
//     const [sendMoneyAmount, setSendMoneyAmount] = useState('');
//     const [channel, setChannel] = useState(2);
//     const [chargesData, setChargesData] = useState(null);
//     const [instantTransfer, setInstantTransfer] = useState(false);
//     const [instantTransferError, setInstantTransferError] = useState(false);

//     // ----- Slab / OTP / Payment Status -----
//     const [transactionData, setTransactionData] = useState(null);
//     const [transactionId, setTransactionId] = useState(null);
//     const [transactionIndex, setTransactionIndex] = useState(0);
//     const [transactionSlab, setTransactionSlab] = useState(null);
//     const [transactionLength, setTransactionSlabLength] = useState(null);
//     const [invoiceData, setInvoiceData] = useState(null);
//     const [otpCode, setOtpCode] = useState(null);
//     const [referenceKey, setReferenceKey] = useState(null);
//     const [isOTPSendingInProgress, setIsOTPSendingInProgress] = useState(false);
//     const [isOTPSubmitInProgress, setIsOTPSubmitInProgress] = useState(false);
//     const [invoiceDataModal, setInvoiceDataModal] = useState(false);
//     const [successTransaction, setSuccessTransaction] = useState([]);
//     const [transactionStatus, setTransactionStatus] = useState(null);
//     const [transactionStatusText, setTransactionStatusText] = useState(null);
//     const [isPaymentStatusModal, setPaymentStatusModal] = useState(false);
//     const [isOtpTransactionModal, setOtpTransactionModal] = useState(false);

//     // ----- Verify Popup & Import -----
//     const [showPopup, setShowPopup] = useState(false);
//     const [selectedRow, setSelectedRow] = useState(null);
//     const [importModal, setImportModal] = useState(false);

//     const isSendingRef = useRef(false);
//     const tableRef = useRef(null);
//     const [sendingRowId, setSendingRowId] = useState(null);

//     // ----- State to track per-row amount errors -----
//     const [amountErrors, setAmountErrors] = useState({});

//     // Lifecycle
//     useEffect(() => {
//         setCustomerMobile(customerMobile);
//         getLocation();
//         if (customerMobile) {
//             getDataReports(customerMobile);
//         }
//         getBankList();
//     }, [customerData]);

//     useEffect(() => {
//         if (timer) clearTimeout(timer);
//         setTimer(setTimeout(() => {
//             if (saveCustomerMobile) {
//                 getDataReports(saveCustomerMobile);
//             }
//         }, 100));
//     }, [searchText]);

//     useEffect(() => {
//         if (saveCustomerMobile) {
//             getDataReports(saveCustomerMobile);
//         }
//     }, [page]);

//     // ----- Helpers -----
//     const getLocation = () => {
//         const userData = getUser();
//         const shopsLat = userData?.data?.shopsLat;
//         const shopsLong = userData?.data?.shopsLong;
//         if (shopsLat !== undefined && shopsLat !== null && Number(shopsLat) !== 0) {
//             setLatitude(Number(shopsLat));
//             setLongitude(Number(shopsLong));
//         } else {
//             navigator.geolocation.getCurrentPosition((data) => {
//                 setLatitude(data.coords.latitude);
//                 setLongitude(data.coords.longitude);
//             });
//         }
//     };

//     const getDataReports = (mobile) => {
//         const senderMobile = mobile || saveCustomerMobile;
//         if (!senderMobile) {
//             console.warn('No sender mobile available');
//             return;
//         }
//         setLoading(true);
//         const params = {
//             senderMobile: senderMobile,
//             limit: isLimit,
//             page: page,
//         };
//         if (searchText) params.search = searchText;
//         const queryString = new URLSearchParams(params).toString();
//         getRequest(`${FINO_IMW_GET_BENEFICIARY_LIST}?${queryString}`, history)
//             .then((response) => {
//                 if (response.success) setData(response.data);
//                 else setData({ docs: [], totalDocs: 0 });
//             })
//             .catch(() => setData({ docs: [], totalDocs: 0 }))
//             .finally(() => setLoading(false));
//     };

//     const handlePageChange = (page) => setPage(page);
//     const handleSearch = (e) => setSearchText(e.target.value);

//     // ----- Bank List & IFSC (used in Add view) -----
//     const getBankList = () => {
//         getRequest(GET_DMT_NEW_BANK_LIST, history)
//             .then((response) => {
//                 if (response.success) {
//                     const bankDataRecord = response.data.filter((item) => item.key === "DMT2.0");
//                     setEKOBankListData(bankDataRecord);
//                     setBankListData([
//                         { value: '', label: '-- Select Bank --' },
//                         ...bankDataRecord.map((item) => ({
//                             value: item.BankID,
//                             label: item.BANK_NAME,
//                         })),
//                     ]);
//                 }
//             })
//             .catch(() => { });
//     };

//     // ----- FIX: Clear beneBankName when bank is selected -----
//     const onChangeBankIfscCode = (value) => {
//         if (value) {
//             const findBank = getEKOBankListData.filter((item) => item.BankID === value);
//             if (findBank.length > 0) {
//                 setSelectedOption({ value: findBank[0].BankID, label: findBank[0].BANK_NAME });
//                 // Clear account holder name on bank change
//                 setBeneData((prev) => ({
//                     ...prev,
//                     bankName: findBank[0].BANK_NAME,
//                     beneBankName: '', // <-- CLEAR
//                 }));
//                 if (findBank[0].ifsc) {
//                     setBeneData((prev) => ({
//                         ...prev,
//                         ifscCode: findBank[0].ifsc,
//                     }));
//                     enterIfscCode({ target: { name: 'ifscCode', value: findBank[0].ifsc } });
//                     setIfscEnable(true);
//                 } else {
//                     setBeneData((prev) => ({ ...prev, ifscCode: '' }));
//                     setIfscEnable(false);
//                 }
//                 setBankId(findBank[0].BankID);
//             } else {
//                 setBankId(null);
//             }
//         } else {
//             setBankId(null);
//             setIfscEnable(false);
//             setBeneData((prev) => ({ ...prev, ifscCode: '', bankName: '', beneBankName: '' }));
//         }
//     };

//     // ----- FIX: Clear beneBankName when IFSC is manually changed -----
//     const enterIfscCode = (event) => {
//         const { name, value } = event.target;
//         setBeneData((prev) => ({ ...prev, [name]: value, beneBankName: '' })); // <-- CLEAR
//         if (isIfscCodeValid(value)) {
//             onChangeIfscCode(value);
//             setBeneError((prev) => ({ ...prev, ifscCodeVaild: 1 }));
//         } else {
//             setBeneError((prev) => ({ ...prev, ifscCodeVaild: 2 }));
//         }
//     };

//     const onChangeIfscCode = (val) => {
//         const value = val || getBeneData.ifscCode;
//         if (isIfscCodeValid(value)) {
//             const payload = { ifsccode: value };
//             postRequest(IFSC_CODE_VERIFY, payload, history)
//                 .then((response) => {
//                     if (response.success) {
//                         const record = response.data.data;
//                         setDataField({
//                             ifscCode: record.ifsc,
//                             address: record.address,
//                             bankName: record.bank,
//                             branchAddress: record.branch,
//                             city: record.city,
//                             state: record.state,
//                         });
//                         setBeneData((prev) => ({
//                             ...prev,
//                             bankName: record.bank,
//                         }));
//                     }
//                 })
//                 .catch(() => { });
//         } else {
//             if (value && value.length === 11) {
//                 toast.error('Please enter valid IFSC code');
//                 setDataField({});
//                 setBeneData((prev) => ({ ...prev, bankName: '' }));
//             }
//         }
//     };

//     // ----- Get bank name from account number (verification) -----
//     const getBankNameFromAccountNumber = () => {
//         if (getBeneData.accountNumber && getBeneData.ifscCode) {
//             setLoading(true);
//             const payload = {
//                 ifsccode: getBeneData.ifscCode,
//                 accountNumber: getBeneData.accountNumber,
//                 externalRef: refId(13),
//                 consent: 'Y',
//                 pennyDrop: 'AUTO',
//                 latitude,
//                 longitude,
//             };
//             postRequest(GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER, payload, history)
//                 .then((response) => {
//                     if (response.success) {
//                         const record = response.data.data;
//                         setBeneData((prev) => ({ ...prev, beneBankName: record.nameAtBank }));
//                         toast.success(`Account holder: ${record.nameAtBank}`);
//                     } else {
//                         toast.error(response.message || 'Failed to verify account');
//                     }
//                     setLoading(false);
//                 })
//                 .catch(() => setLoading(false));
//         } else {
//             toast.error('Please enter valid account number and IFSC');
//         }
//     };

//     // ----- Add Beneficiary (dedicated view) -----
//     const openAddView = () => {
//         setView('add');
//         setBeneData({});
//         setBeneError({});
//         setSelectedOption(null);
//         setDataField({});
//         setIfscEnable(false);
//     };

//     const closeAddView = () => {
//         setView('list');
//         setBeneData({});
//         setBeneError({});
//     };

//     const FormBaneValidate = () => {
//         const fields = ['beneName', 'beneficiaryMobile', 'ifscCode', 'accountNumber'];
//         const errors = {};
//         let valid = true;
//         fields.forEach((f) => {
//             if (!getBeneData[f]) {
//                 errors[f] = true;
//                 valid = false;
//             }
//         });
//         setBeneError(errors);
//         return valid;
//     };

//     const addBaneSave = () => {
//         if (FormBaneValidate()) {
//             setLoading(true);
//             const payload = {
//                 senderMobile: saveCustomerMobile,
//                 beneficiaryMobile: getBeneData.beneficiaryMobile,
//                 accountNumber: getBeneData.accountNumber,
//                 ifscCode: getBeneData.ifscCode,
//                 bankId: bankId,
//                 beneficiaryName: getBeneData.beneName,
//                 bankName: getBeneData.bankName || '',
//                 beneBankName: getBeneData.beneBankName || ''
//             };
//             postRequest(FINO_IMW_ADD_BENEFICIARY, payload, history)
//                 .then((response) => {
//                     if (response.success) {
//                         closeAddView();
//                         getDataReports(saveCustomerMobile);
//                         toast.success(response.message || 'Beneficiary added successfully');
//                     } else {
//                         toast.error(response.message || response.msg || 'Failed to add beneficiary');
//                     }
//                     setLoading(false);
//                 })
//                 .catch(() => {
//                     setLoading(false);
//                     toast.error('Failed to add beneficiary');
//                 });
//         }
//     };

//     const onChangeAddBene = (e) => {
//         const { name, value } = e.target;
//         setBeneData((prev) => ({ ...prev, [name]: value }));
//     };

//     const onChangeAddBeneName = (e) => {
//         const { name, value } = e.target;
//         if (isAlphabetOnly(value)) {
//             setBeneData((prev) => ({ ...prev, [name]: value }));
//         } else {
//             e.preventDefault();
//         }
//     };

//     // ----- Update Beneficiary (used for existing beneficiaries) -----
//     const updateBeneData = (data) => {
//         let params = {}
//         params.id = data._id;
//         params.beneBankName = data.beneBankName;
//         postRequest(UPDATE_DMT_JIO_BENEFICIARY_DETAIL, params).then((response) => {
//             if (response.success === true) {
//                 getDataReports();
//             }
//         }).catch(function (error) {
//             // console.log(error);
//         })
//     };

//     // ----- Update Beneficiary (full update via add API) -----
//     const updateBeneficiary = (row) => {
//         const beneName = row.beneName || row.beneBankName || row.bankName || 'Beneficiary';
//         setLoading(true);
//         const payload = {
//             senderMobile: saveCustomerMobile,
//             beneficiaryMobile: row.beneMobile || saveCustomerMobile,
//             beneficiaryName: beneName,
//             accountNumber: row.accountNumber,
//             ifscCode: row.ifscCode,
//             bankName: row.bankName || '',
//             beneBankName: row.beneBankName || '',
//             update: true,
//         };
//         postRequest(FINO_IMW_ADD_BENEFICIARY, payload, history)
//             .then((response) => {
//                 if (response.success) {
//                     getDataReports(saveCustomerMobile);
//                     toast.success('Beneficiary updated successfully');
//                 } else {
//                     toast.error(response.message || response.msg || 'Update failed');
//                 }
//                 setLoading(false);
//             })
//             .catch(() => {
//                 setLoading(false);
//                 toast.error('Update failed');
//             });
//     };

//     // ----- Toggle Status (Activate/Deactivate) -----
//     const toggleStatus = (row, status) => {
//         setLoading(true);
//         const payload = {
//             id: row._id,
//             status: status,
//         };
//         postRequest(UPDATE_DMT_JIO_BENEFICIARY_STATUS, payload, history)
//             .then((response) => {
//                 if (response.success) {
//                     getDataReports();
//                     toast.success(response.message || `Beneficiary ${status ? 'activated' : 'deactivated'} successfully`);
//                 } else {
//                     toast.error(response.message || 'Failed to update status');
//                 }
//                 setLoading(false);
//             })
//             .catch(() => {
//                 setLoading(false);
//                 toast.error('Error updating status');
//             });
//     };

//     // ----- Sync Beneficiaries -----
//     const syncBeneficiaries = () => {
//         const params = {
//             senderMobile: saveCustomerMobile,
//             sync: true,
//             latitude: latitude || '0',
//             longitude: longitude || '0',
//         };
//         const queryString = new URLSearchParams(params).toString();
//         getRequest(`${FINO_IMW_GET_BENEFICIARY_LIST}?${queryString}`, history)
//             .then((response) => {
//                 if (response.success) {
//                     setData(response.data);
//                     toast.success('Beneficiaries synced successfully');
//                 } else {
//                     toast.error(response.message || response.msg || 'Sync failed');
//                 }
//             })
//             .catch(() => toast.error('Sync failed'));
//     };

//     // ----- Import Beneficiary -----
//     const importBaneficiarySave = (data) => {
//         if (data) {
//             setLoading(true);

//             let bankName = data.bankName || '';
//             if (!bankName && data.bankId) {
//                 const foundBank = getEKOBankListData.find(b => b.BankID === data.bankId);
//                 if (foundBank) bankName = foundBank.BANK_NAME;
//             }

//             const payload = {
//                 senderMobile: saveCustomerMobile,
//                 beneficiaryMobile: data.recipientMobile,
//                 accountNumber: data.accountNumber,
//                 ifscCode: data.ifscCode,
//                 bankId: data.bankId,
//                 beneficiaryName: data.recipientName,
//                 bankName: bankName,
//                 beneBankName: data.beneBankName || ''
//             };

//             postRequest(FINO_IMW_ADD_BENEFICIARY, payload, history)
//                 .then((response) => {
//                     if (response.success) {
//                         setImportModal(false);
//                         getDataReports();
//                         toast.success(response.message);
//                     } else {
//                         toast.error(response.message);
//                     }
//                     setLoading(false);
//                 })
//                 .catch(() => {
//                     setLoading(false);
//                     toast.error('Import failed');
//                 });
//         }
//     };

//     // ----- Verify Beneficiary with Bank Popup -----
//     const openBankSelection = (row) => {
//         setSelectedRow(row);
//         setShowPopup(true);
//     };

//     // ----- getName (updates with new name) -----
//     const getName = (data, recheck) => {
//         if (data.accountNumber && data.ifscCode) {
//             setLoading(true);
//             const payload = {
//                 ifsccode: data.ifscCode,
//                 accountNumber: data.accountNumber,
//                 externalRef: refId(13),
//                 consent: 'Y',
//                 pennyDrop: 'AUTO',
//                 recheck: recheck,
//                 latitude: latitude,
//                 longitude: longitude
//             };
//             postRequest(GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER, payload, history)
//                 .then((response) => {
//                     if (response.success) {
//                         const newName = response.data.data.nameAtBank;
//                         toast.success(`Verified: ${newName}`);
//                         updateBeneData({ _id: data._id, beneBankName: newName });
//                         getDataReports();
//                     } else {
//                         toast.error(response.message);
//                     }
//                     setLoading(false);
//                 })
//                 .catch(() => {
//                     setLoading(false);
//                     toast.error('Verification failed');
//                 });
//         } else {
//             toast.error('Missing account number or IFSC');
//         }
//     };

//     // ----- Send Money with Limit Validation -----
//     const openSendView = (row) => {
//         if (!row.imwBeneID) {
//             toast.error('Beneficiary not registered with Fino. Please update first.');
//             return;
//         }
//         if (!row.amount) {
//             toast.error('Enter amount in the table');
//             return;
//         }
//         const amt = parseFloat(row.amount);
//         if (amt < 100) { toast.error('Min ₹100'); return; }
//         if (amt > 25000) { toast.error('Max ₹25,000'); return; }

//         if (amt > availableLimit) {
//             toast.error(`Amount exceeds available limit of ₹${availableLimit.toLocaleString()}`);
//             return;
//         }

//         setSendMoneyAmount('');
//         setChargesData(null);
//         setInstantTransfer(false);
//         setInstantTransferError(false);

//         setSelectedSendRow(row);
//         setChannel(2);
//         setSendingRowId(row._id);
//         setView('send');

//         const payload = {
//             beneAutoId: row._id,
//             customer_id: saveCustomerMobile,
//             accountNumber: row.accountNumber,
//             ifsccode: row.ifscCode,
//             amount: row.amount,
//             latitude: latitude || '0',
//             longitude: longitude || '0',
//             channel: 2,
//             serviceName: 'FINO',
//         };
//         handleConfirmSubmit(payload);
//     };

//     const closeSendView = () => {
//         setView('list');
//         setSelectedSendRow(null);
//         setSendingRowId(null);
//         setChargesData(null);
//         setSendMoneyAmount('');
//         setInstantTransfer(false);
//         setInstantTransferError(false);
//     };

//     // ----- Confirm Initiate (get charges) -----
//     const handleConfirmSubmit = (payload) => {
//         setLoading(true);
//         postRequest(POST_DMT_PAY_SPRINT_CONFIRM_INITIATE_TRANSACTION, payload, history)
//             .then((res) => {
//                 if (res.success) {
//                     setChargesData(res.data);
//                 } else {
//                     toast.error(res.message || res.msg || 'Failed to confirm transaction');
//                     closeSendView();
//                 }
//                 setLoading(false);
//             })
//             .catch((err) => {
//                 setLoading(false);
//                 toast.error(err.message || 'Network error');
//                 closeSendView();
//             });
//     };

//     // ----- Final Confirmation & Initiate -----
//     const handleSaveSend = (data) => {
//         const typedAmount = parseFloat(sendMoneyAmount);
//         const originalAmount = parseFloat(data.amount);
//         if (isNaN(typedAmount) || typedAmount !== originalAmount) {
//             toast.error('Amount does not match the original amount. Please re‑enter exactly.');
//             return;
//         }
//         const payload = {
//             beneAutoId: data._id,
//             customer_id: saveCustomerMobile,
//             accountNumber: data.accountNumber,
//             ifsccode: data.ifscCode,
//             amount: typedAmount,
//             latitude: latitude || '0',
//             longitude: longitude || '0',
//             channel: data.isChannel || 2,
//             devicetype: 'W',
//             serviceName: 'FINO',
//             nameOfBank: data.bankName || '',
//         };
//         handleSubmit(payload);
//     };

//     // ----- handleSubmit -----
//     const handleSubmit = (payload) => {
//         setLoading(true);
//         postRequest(FINO_IMW_INITIATE, payload, history)
//             .then((res) => {
//                 if (res.success) {
//                     setTransactionData(res.data);
//                     setSendingRowId(null);
//                     if (res.invoice) {
//                         getDataReports(saveCustomerMobile);
//                         handleInvoice(res.data);
//                         closeSendView();
//                     } else {
//                         setTransactionIndex(0);
//                         let slabarray = res.transactionSlab;
//                         setTransactionSlab(slabarray);
//                         setTransactionSlabLength(slabarray.length);
//                         if (slabarray.length === 1) {
//                             setView('otp');
//                             generateTransaction(slabarray[0]);
//                         } else {
//                             setView('otpBatch');
//                             generateTransaction(slabarray[0]);
//                         }
//                     }
//                     setSuccessTransaction([]);
//                     toast.success(res.message || 'Transaction initiated');
//                 } else {
//                     toast.error(res.message || res.msg || 'Failed to initiate transaction');
//                     setSendingRowId(null);
//                     closeSendView();
//                 }
//                 setLoading(false);
//             })
//             .catch((err) => {
//                 setLoading(false);
//                 toast.error(err.message || 'Network error');
//                 setSendingRowId(null);
//                 closeSendView();
//             });
//     };

//     // ----- Generate OTP -----
//     const generateTransaction = (slab) => {
//         if (!slab) return;
//         if (isSendingRef.current) return;

//         isSendingRef.current = true;
//         setIsOTPSendingInProgress(true);

//         const payload = { transactionId: slab.transactionId };
//         postRequest(FINO_IMW_GENERATE, payload, history)
//             .then((res) => {
//                 if (res.success) {
//                     setTransactionId(slab.transactionId);
//                     setReferenceKey(res.data.referenceKey);
//                     setOtpCode(null);
//                     toast.success(res.message || 'OTP sent');
//                     setTransactionSlab((prev) =>
//                         prev.map((item) =>
//                             item.transactionId === slab.transactionId
//                                 ? { ...item, otpSent: true }
//                                 : item
//                         )
//                     );
//                     if (transactionLength === 1) {
//                         setOtpTransactionModal(true);
//                     }
//                 } else {
//                     setView('list');
//                     toast.dismiss();
//                     toast.error(res.message || res.msg || 'Failed to send OTP');
//                     closeSendView();
//                 }
//             })
//             .catch((err) => {
//                 setView('list');
//                 toast.error(err.message || 'Network error');
//                 closeSendView();
//             })
//             .finally(() => {
//                 isSendingRef.current = false;
//                 setIsOTPSendingInProgress(false);
//             });
//     };

//     // ----- Next slab -----
//     const generateNextTransaction = () => {
//         setPaymentStatusModal(false);
//         onChangeOtpValue(null);

//         if (transactionIndex === transactionLength) {
//             getDataReports(saveCustomerMobile);
//             setTransactionStatus(null);
//             setTransactionStatusText(null);
//             handleInvoice(transactionData);
//             setView('list');
//             closeSendView();
//         } else {
//             setTransactionIndex(transactionIndex + 1);
//             generateTransaction(transactionSlab[transactionIndex + 1]);
//         }
//     };

//     // ----- handlePayment -----
//     const handlePayment = () => {
//         if (!otpCode) {
//             toast.error('Enter OTP');
//             return;
//         }
//         setIsOTPSubmitInProgress(true);
//         const payload = {
//             transactionId: transactionId,
//             otp: otpCode,
//             referenceKey: referenceKey,
//         };
//         postRequest(FINO_IMW_PAYMENT_TRANSFER, payload, history)
//             .then((res) => {
//                 if (res?.success === false && res?.noResponse === true) {
//                     let array = successTransaction;
//                     array.push(transactionId);
//                     setSuccessTransaction([...array]);
//                     if (transactionSlab[transactionIndex + 1]?.transactionId) {
//                         setTransactionId(transactionSlab[transactionIndex + 1]?.transactionId);
//                     }
//                     setTransactionSlab((prev) =>
//                         prev.map((item) =>
//                             item.transactionId === transactionId
//                                 ? { ...item, statusCode: 1, statusText: 'Success' }
//                                 : item
//                         )
//                     );
//                     handlePaymentFail();
//                     setIsOTPSubmitInProgress(false);
//                     return;
//                 }

//                 if (res.success) {
//                     let array = successTransaction;
//                     array.push(transactionId);
//                     setSuccessTransaction([...array]);

//                     if (res.invoice) {
//                         getDataReports(saveCustomerMobile);
//                         setTransactionStatus(null);
//                         setTransactionStatusText(null);
//                         handleInvoice(res.data);
//                         setView('list');
//                         closeSendView();
//                     } else if (transactionIndex === transactionLength) {
//                         getDataReports(saveCustomerMobile);
//                         setTransactionStatus(null);
//                         setTransactionStatusText(null);
//                         handleInvoice(transactionData);
//                         setView('list');
//                         closeSendView();
//                     } else {
//                         setTransactionSlab((prev) =>
//                             prev.map((item) =>
//                                 item.transactionId === transactionId
//                                     ? { ...item, statusCode: res.statusCode, statusText: res.statusText }
//                                     : item
//                             )
//                         );
//                         const nextIndex = transactionIndex + 1;
//                         if (nextIndex <= transactionLength) {
//                             setTransactionIndex(nextIndex);
//                             generateTransaction(transactionSlab[nextIndex]);
//                         }
//                     }
//                 } else if (!res.success && !res.invoice) {
//                     toast.error(res.message || res.msg || 'Transaction failed');
//                     setTransactionStatus('1');
//                     setTransactionStatusText('Failed');
//                     setPaymentStatusModal(true);
//                 } else {
//                     setTransactionStatus('1');
//                     setTransactionStatusText('Failed');
//                     setView('list');
//                     toast.error(res.message || res.msg || 'Transaction failed');
//                     closeSendView();
//                 }
//                 setIsOTPSubmitInProgress(false);
//             })
//             .catch((err) => {
//                 toast.error(err.message || 'Network error');
//                 setIsOTPSubmitInProgress(false);
//                 closeSendView();
//             });
//     };

//     // ----- Failure handling -----
//     const handlePaymentFail = () => {
//         if (!successTransaction || transactionSlab?.length === 0) {
//             setTransactionStatus(null);
//             setTransactionStatusText(null);
//             setPaymentStatusModal(false);
//             setSendingRowId(null);
//             setView('list');
//             if (transactionData) {
//                 handleInvoice(transactionData);
//             }
//             closeSendView();
//             return;
//         }

//         if (successTransaction && transactionSlab) {
//             const unmatchedObjects = transactionSlab.filter(item => !successTransaction.includes(item.transactionId));
//             if (unmatchedObjects.length === 0) {
//                 setView('list');
//                 if (transactionData) {
//                     handleInvoice(transactionData);
//                 }
//                 closeSendView();
//                 return;
//             }
//             postRequest(`${POST_DMT_FAILED_BY_PARTNER}`, { data: JSON.stringify(unmatchedObjects) }, history)
//                 .then((response) => {
//                     if (response.success === true) {
//                         getDataReports(saveCustomerMobile);
//                         handleInvoice(transactionData);
//                     } else {
//                         toast.error(response.message || response.msg || 'Failed to cancel transaction');
//                     }
//                     setLoading(false);
//                 })
//                 .catch(function (error) {
//                     setLoading(false);
//                     toast.error('Failed to cancel transaction');
//                 });
//         }
//         setTransactionStatus(null);
//         setTransactionStatusText(null);
//         setPaymentStatusModal(false);
//         setSendingRowId(null);
//         setView('list');
//         closeSendView();
//     };

//     const confirmCancelTransaction = () => {
//         Modal.confirm({
//             title: 'Cancel Transaction?',
//             content: (
//                 <div>
//                     <p>Are you sure you want to cancel this transaction?</p>
//                     <p style={{ color: 'red', marginBottom: 0 }}>
//                         Your remaining transactions will be marked as failed.
//                     </p>
//                 </div>
//             ),
//             okText: 'Yes, Cancel',
//             cancelText: 'No',
//             okType: 'danger',
//             onOk: () => {
//                 handlePaymentFail();
//             },
//         });
//     };

//     const handleInvoice = (data) => {
//         setInvoiceData(data);
//         history.push(`/dmtinvoice/${data.client_ref_id}`);
//     };

//     const handleAmount = (e) => {
//         setSendMoneyAmount(e.target.value);
//     };

//     // ----- Updated handleEditRowAmount with limit validation -----
//     const handleEditRowAmount = (e, index) => {
//         const value = e.target.value;
//         const newData = [...getData.docs];
//         newData[index].amount = value;
//         setData({ ...getData, docs: newData });

//         const amt = parseFloat(value);
//         const errors = { ...amountErrors };
//         if (!isNaN(amt) && amt > 0) {
//             if (amt > availableLimit) {
//                 errors[index] = `Amount exceeds available limit of ₹${availableLimit.toLocaleString()}`;
//             } else if (amt < 100) {
//                 errors[index] = 'Minimum amount is ₹100';
//             } else if (amt > 25000) {
//                 errors[index] = 'Maximum amount is ₹25,000';
//             } else {
//                 delete errors[index];
//             }
//         } else {
//             delete errors[index];
//         }
//         setAmountErrors(errors);
//     };

//     const onChangeChannel = ({ target: { value } }) => {
//         setChannel(value);
//         if (selectedSendRow) {
//             setSelectedSendRow({ ...selectedSendRow, isChannel: value });
//         }
//     };

//     const onChangeCheckbox = (e) => {
//         if (e.target.checked) {
//             if (chargesData && parseFloat(chargesData.instantLimit) < sendMoneyAmount) {
//                 setInstantTransferError(true);
//             } else {
//                 setInstantTransfer(true);
//                 setInstantTransferError(false);
//             }
//         } else {
//             setInstantTransfer(false);
//             setInstantTransferError(false);
//         }
//     };

//     const onChangeOtpValue = (e) => setOtpCode(e?.target?.value || e);

//     // ----- Table Columns (fonts scaled) -----
//     const columns = [
//         {
//             name: 'Beneficiary',
//             selector: (row) => (
//                 <div>
//                     <div style={{ fontWeight: 600, color: '#1A1A2E', fontSize: fs(14) }}>{row.beneName || ''}</div>
//                     <div style={{ fontSize: fs(12), color: '#6B7280' }}>{row.beneMobile && `Mobile: ${row.beneMobile}`}</div>
//                     <div style={{ fontSize: '12px', color: '#d13e12' }}><strong>{row.remarks && `${row.remarks}`}</strong></div>
//                 </div>
//             ),
//             width: '270px',
//         },
//         {
//             name: 'Account Details',
//             selector: (row) => (
//                 <div>
//                     <div style={{ fontSize: fs(14) }}><strong style={{ color: '#1A1A2E' }}>Name :</strong> {row.beneBankName}</div>
//                     <div style={{ fontSize: fs(14) }}><strong style={{ color: '#1A1A2E' }}>A/C :</strong> {row.accountNumber}</div>
//                     <div style={{ fontSize: fs(12), color: '#6B7280' }}><strong>IFSC:</strong> {row.ifscCode}</div>
//                 </div>
//             ),
//             width: '250px',
//         },
//         {
//             name: 'Bank',
//             selector: (row) => (
//                 <div>
//                     <div style={{ fontSize: fs(14) }}>{row.bankName}</div>
//                     <div style={{ fontSize: fs(12), marginTop: 3 }}>
//                         {row.isVerified ? (
//                             <span style={{ color: primaryGreen, fontWeight: 500 }}><CheckOutlined /> Verified</span>
//                         ) : (
//                             <span style={{ color: '#F59E0B', fontWeight: 500 }}><CloseOutlined /> Pending</span>
//                         )}
//                     </div>
//                 </div>
//             ),
//             width: '200px',
//         },
//         {
//             name: 'Verified',
//             selector: (row) => (
//                 <>
//                     {row.isVerified ? (
//                         <button
//                             onClick={() => openBankSelection(row)}
//                             className="pointer text-success"
//                             disabled={!row.isActive}
//                             style={{
//                                 background: 'transparent',
//                                 border: 'none',
//                                 color: '#28a745',
//                                 fontWeight: 600,
//                                 cursor: 'pointer',
//                                 fontSize: fs(13),
//                             }}
//                         >
//                             RE-VERIFY
//                         </button>
//                     ) : (
//                         <button
//                             onClick={() => openBankSelection(row)}
//                             className="pointer text-danger"
//                             disabled={!row.isActive}
//                             style={{
//                                 background: 'transparent',
//                                 border: 'none',
//                                 color: '#dc3545',
//                                 fontWeight: 600,
//                                 cursor: 'pointer',
//                                 fontSize: fs(13),
//                             }}
//                         >
//                             GET NAME
//                         </button>
//                     )}
//                 </>
//             ),
//             width: '120px',
//         },
//         {
//             name: 'Status',
//             selector: (row) => {
//                 if (row.isDeleted) {
//                     return <span className="badge badge-danger" style={{ fontSize: fs(13) }}>Deleted</span>;
//                 } else if (row.isActive) {
//                     return (
//                         <button
//                             onClick={() => toggleStatus(row, false)}
//                             className="pointer text-success"
//                             style={{
//                                 background: 'transparent',
//                                 border: 'none',
//                                 color: '#28a745',
//                                 fontWeight: 600,
//                                 cursor: 'pointer',
//                                 fontSize: fs(13),
//                             }}
//                         >
//                             Active
//                         </button>
//                     );
//                 } else {
//                     return (
//                         <button
//                             onClick={() => toggleStatus(row, true)}
//                             className="pointer text-danger"
//                             style={{
//                                 background: 'transparent',
//                                 border: 'none',
//                                 color: '#dc3545',
//                                 fontWeight: 600,
//                                 cursor: 'pointer',
//                                 fontSize: fs(13),
//                             }}
//                         >
//                             Deactive
//                         </button>
//                     );
//                 }
//             },
//             width: '120px',
//         },
//         {
//             name: 'Amount (₹)',
//             selector: (row, index) => (
//                 <div>
//                     <input
//                         type="text"
//                         name="amount"
//                         className="form-control"
//                         onChange={(e) => handleEditRowAmount(e, index)}
//                         placeholder="Enter Amount"
//                         onKeyDown={isNumber}
//                         maxLength="6"
//                         disabled={!row.isActive || row.isDeleted || !row.imwBeneID}
//                         style={{
//                             ...inputStyle,
//                             height: '42px',
//                             width: '150px',
//                             fontSize: fs(14),
//                             padding: '0 10px',
//                         }}
//                         onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
//                         onBlur={(e) => { e.target.style.borderColor = cardBorder; e.target.style.boxShadow = 'none'; }}
//                     />
//                     {amountErrors[index] && (
//                         <div style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px' }}>
//                             {amountErrors[index]}
//                         </div>
//                     )}
//                 </div>
//             ),
//             width: '220px',
//         },
//         {
//             name: 'Action',
//             selector: (row) => {
//                 const index = getData.docs.indexOf(row);
//                 const isAmountValid = !amountErrors[index];
//                 return (
//                     <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
//                         {!row.isDeleted && row.isActive && row.imwBeneID && (
//                             <button
//                                 className="btn btn-primary btn-sm"
//                                 onClick={() => openSendView(row)}
//                                 disabled={sendingRowId !== null || !isAmountValid || !row.amount}
//                                 style={{
//                                     background: `linear-gradient(135deg, ${primaryRed}, #E8454B)`,
//                                     border: 'none',
//                                     borderRadius: '8px',
//                                     padding: '0 14px',
//                                     color: '#fff',
//                                     fontWeight: 600,
//                                     fontSize: fs(12),
//                                     height: '32px',
//                                     cursor: (sendingRowId === row._id || !isAmountValid) ? 'not-allowed' : 'pointer',
//                                     opacity: (sendingRowId === row._id || !isAmountValid) ? 0.6 : 1,
//                                     transition: 'all 0.3s ease',
//                                     display: 'inline-flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                 }}
//                                 onMouseOver={(e) => {
//                                     if (sendingRowId !== row._id && isAmountValid) {
//                                         e.target.style.transform = 'translateY(-2px)';
//                                         e.target.style.boxShadow = '0 4px 12px rgba(201,38,44,0.3)';
//                                     }
//                                 }}
//                                 onMouseOut={(e) => {
//                                     e.target.style.transform = 'translateY(0)';
//                                     e.target.style.boxShadow = 'none';
//                                 }}
//                             >
//                                 {sendingRowId === row._id ? (
//                                     <>
//                                         <LoadingOutlined spin style={{ fontSize: fs(12) }} />
//                                         Processing...
//                                     </>
//                                 ) : (
//                                     'Send'
//                                 )}
//                             </button>
//                         )}
//                         {!row.isDeleted && !row.imwBeneID && (
//                             <button
//                                 className="btn btn-warning btn-sm"
//                                 onClick={() => updateBeneficiary(row)}
//                                 disabled={row.isDeleted}
//                                 style={{
//                                     background: `linear-gradient(135deg, ${primaryOrange}, #F59E0B)`,
//                                     border: 'none',
//                                     borderRadius: '8px',
//                                     padding: '0 14px',
//                                     color: '#fff',
//                                     fontWeight: 600,
//                                     fontSize: fs(12),
//                                     height: '32px',
//                                     cursor: 'pointer',
//                                     transition: 'all 0.3s ease',
//                                     display: 'inline-flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                 }}
//                                 onMouseOver={(e) => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 4px 12px rgba(255,140,0,0.3)'; }}
//                                 onMouseOut={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = 'none'; }}
//                             >
//                                 Update
//                             </button>
//                         )}
//                     </div>
//                 );
//             },
//             width: '180px',
//         },
//     ];

//     // ----- Loading -----
//     if (isLoading) {
//         return (
//             <div className="content text-center" style={{ margin: '100px 0' }}>
//                 <PropagateLoader color={primaryRed} loading={isLoading} size={25} />
//             </div>
//         );
//     }

//     // ----- Render based on view -----
//     const renderView = () => {
//         switch (view) {
//             case 'list':
//                 return (
//                     <>
//                         {/* Header Card */}
//                         <div style={{
//                             background: '#fff',
//                             borderRadius: '20px',
//                             padding: '24px 30px',
//                             marginBottom: '20px',
//                             boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
//                             border: `1px solid ${cardBorder}`,
//                         }}>
//                             <div className="row align-items-center">
//                                 <div className="col-md-6">
//                                     <h4 style={{ fontWeight: 700, color: '#1A1A2E', margin: 0, display: 'flex', alignItems: 'center', fontSize: fs(20) }}>
//                                         <i className="fa fa-users" style={{ color: primaryRed, marginRight: '10px' }}></i>
//                                         Beneficiary List
//                                     </h4>
//                                     <p style={{ color: '#6B7280', margin: '4px 0 0', fontSize: fs(14) }}>
//                                         Manage your Fino DMT beneficiaries
//                                     </p>
//                                     <p style={{ color: '#1A1A2E', marginTop: '4px', fontSize: '14px', fontWeight: 500 }}>
//                                         Available Limit: <span style={{ color: primaryRed, fontWeight: 700 }}>₹{availableLimit.toLocaleString()}</span>
//                                     </p>
//                                 </div>
//                                 <div className="col-md-6 text-right" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', flexWrap: 'wrap' }}>
//                                     <button
//                                         type="button"
//                                         className="btn btn-outline-secondary"
//                                         onClick={syncBeneficiaries}
//                                         style={{
//                                             borderColor: cardBorder,
//                                             color: '#4A4A6A',
//                                             borderRadius: '10px',
//                                             padding: '0 18px',
//                                             transition: 'all 0.3s ease',
//                                             background: '#fff',
//                                             fontSize: fs(13),
//                                             height: '40px',
//                                             display: 'inline-flex',
//                                             alignItems: 'center',
//                                             justifyContent: 'center',
//                                         }}
//                                         onMouseOver={(e) => { e.target.style.borderColor = primaryRed; e.target.style.color = primaryRed; }}
//                                         onMouseOut={(e) => { e.target.style.borderColor = cardBorder; e.target.style.color = '#4A4A6A'; }}
//                                     >
//                                         <SyncOutlined /> Sync
//                                     </button>
//                                     <button
//                                         type="button"
//                                         className="btn"
//                                         onClick={() => setImportModal(true)}
//                                         style={{
//                                             background: `linear-gradient(135deg, ${primaryOrange}, #F59E0B)`,
//                                             color: '#fff',
//                                             border: 'none',
//                                             borderRadius: '10px',
//                                             padding: '0 18px',
//                                             fontWeight: 600,
//                                             boxShadow: '0 4px 12px rgba(255,140,0,0.25)',
//                                             transition: 'all 0.3s ease',
//                                             fontSize: fs(13),
//                                             height: '40px',
//                                             display: 'inline-flex',
//                                             alignItems: 'center',
//                                             justifyContent: 'center',
//                                         }}
//                                         onMouseOver={(e) => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 6px 20px rgba(255,140,0,0.35)'; }}
//                                         onMouseOut={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 4px 12px rgba(255,140,0,0.25)'; }}
//                                     >
//                                         <i className="fa fa-users"></i> Import
//                                     </button>
//                                     <button
//                                         type="button"
//                                         className="btn"
//                                         onClick={openAddView}
//                                         style={{
//                                             background: `linear-gradient(135deg, ${primaryRed}, #E8454B)`,
//                                             color: '#fff',
//                                             border: 'none',
//                                             borderRadius: '10px',
//                                             padding: '0 20px',
//                                             fontWeight: 600,
//                                             boxShadow: '0 4px 12px rgba(201,38,44,0.25)',
//                                             transition: 'all 0.3s ease',
//                                             fontSize: fs(13),
//                                             height: '40px',
//                                             display: 'inline-flex',
//                                             alignItems: 'center',
//                                             justifyContent: 'center',
//                                         }}
//                                         onMouseOver={(e) => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 6px 20px rgba(201,38,44,0.35)'; }}
//                                         onMouseOut={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 4px 12px rgba(201,38,44,0.25)'; }}
//                                     >
//                                         <PlusOutlined /> Add Beneficiary
//                                     </button>
//                                 </div>
//                             </div>
//                             <div className="row mt-3">
//                                 <div className="col-md-6">
//                                     <div style={{ display: 'flex', alignItems: 'center', borderRadius: '12px', overflow: 'hidden', border: `1px solid ${cardBorder}`, background: '#fff' }}>
//                                         <input
//                                             className="form-control"
//                                             type="search"
//                                             value={searchText}
//                                             onKeyDown={isNumber}
//                                             placeholder="Search Account Number..."
//                                             maxLength="20"
//                                             onChange={handleSearch}
//                                             style={{
//                                                 ...inputStyle,
//                                                 border: 'none',
//                                                 height: '44px',
//                                                 fontSize: fs(14),
//                                                 flex: 1,
//                                             }}
//                                         />
//                                         <button
//                                             className="btn"
//                                             type="button"
//                                             onClick={() => getDataReports(saveCustomerMobile)}
//                                             style={{
//                                                 background: primaryRed,
//                                                 color: '#fff',
//                                                 border: 'none',
//                                                 padding: '0 20px',
//                                                 borderRadius: '0 12px 12px 0',
//                                                 transition: 'background 0.3s',
//                                                 fontSize: fs(14),
//                                                 height: '44px',
//                                                 display: 'inline-flex',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'center',
//                                             }}
//                                             onMouseOver={(e) => e.target.style.background = '#B82228'}
//                                             onMouseOut={(e) => e.target.style.background = primaryRed}
//                                         >
//                                             <i className="fa fa-search" />
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Data Table */}
//                         <div ref={tableRef} style={{
//                             background: '#fff',
//                             borderRadius: '20px',
//                             padding: '20px',
//                             boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
//                             border: `1px solid ${cardBorder}`,
//                             overflowX: 'auto',
//                         }}>
//                             <DataTable
//                                 columns={columns}
//                                 data={getData.docs || []}
//                                 highlightOnHover
//                                 pagination
//                                 paginationServer
//                                 paginationTotalRows={getData.totalDocs || 0}
//                                 onChangeRowsPerPage={setLimit}
//                                 onChangePage={handlePageChange}
//                                 noDataComponent="No beneficiaries found. Please add a beneficiary."
//                                 customStyles={{
//                                     headRow: {
//                                         style: {
//                                             backgroundColor: '#F9FAFB',
//                                             borderRadius: '12px 12px 0 0',
//                                             borderBottom: `2px solid ${cardBorder}`,
//                                         }
//                                     },
//                                     headCells: {
//                                         style: {
//                                             fontWeight: 600,
//                                             color: '#1A1A2E',
//                                             fontSize: fs(14),
//                                             padding: '12px 16px',
//                                         }
//                                     },
//                                     rows: {
//                                         style: {
//                                             borderBottom: `1px solid ${cardBorder}`,
//                                             fontSize: fs(14),
//                                             padding: '8px 0',
//                                             transition: 'background 0.2s',
//                                         },
//                                         hoverStyle: {
//                                             background: '#F8F9FC',
//                                         }
//                                     },
//                                     cells: {
//                                         style: {
//                                             padding: '10px 16px',
//                                         }
//                                     }
//                                 }}
//                             />
//                         </div>
//                     </>
//                 );

//             case 'add':
//                 return (
//                     <div style={{
//                         background: '#fff',
//                         borderRadius: '20px',
//                         padding: '30px',
//                         boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
//                         border: `1px solid ${cardBorder}`,
//                     }}>
//                         <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
//                             <button
//                                 onClick={closeAddView}
//                                 style={{
//                                     background: 'transparent',
//                                     border: 'none',
//                                     color: primaryRed,
//                                     fontSize: fs(16),
//                                     fontWeight: 600,
//                                     cursor: 'pointer',
//                                     display: 'inline-flex',
//                                     alignItems: 'center',
//                                     gap: '6px',
//                                     padding: '8px 16px',
//                                     borderRadius: '8px',
//                                     transition: 'background 0.2s',
//                                     height: '44px',
//                                 }}
//                                 onMouseOver={(e) => e.currentTarget.style.background = '#f1f5f9'}
//                                 onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
//                             >
//                                 <ArrowLeftOutlined /> Back
//                             </button>
//                             <h5 style={{ margin: '0 0 0 16px', color: '#1A1A2E', fontWeight: 700, fontSize: fs(20) }}>
//                                 <PlusOutlined style={{ marginRight: 8, color: primaryRed }} /> Add New Beneficiary
//                             </h5>
//                         </div>

//                         <div className="row">
//                             <div className="col-md-6">
//                                 <label style={{ fontWeight: 600, color: '#1A1A2E', marginBottom: 6, fontSize: fs(14) }}>Beneficiary Name *</label>
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     name="beneName"
//                                     placeholder="Enter Beneficiary Name"
//                                     onChange={onChangeAddBeneName}
//                                     value={getBeneData.beneName}
//                                     maxLength="50"
//                                     style={inputStyle}
//                                     onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
//                                     onBlur={(e) => { e.target.style.borderColor = cardBorder; e.target.style.boxShadow = 'none'; }}
//                                 />
//                                 {getBeneError.beneName && <span className="error text-danger" style={{ fontSize: fs(13) }}>Required</span>}
//                             </div>
//                             <div className="col-md-6">
//                                 <label style={{ fontWeight: 600, color: '#1A1A2E', marginBottom: 6, fontSize: fs(14) }}>Beneficiary Mobile *</label>
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     name="beneficiaryMobile"
//                                     placeholder="Enter 10-digit Mobile Number"
//                                     onChange={onChangeAddBene}
//                                     value={getBeneData.beneficiaryMobile}
//                                     maxLength="10"
//                                     onKeyDown={isNumber}
//                                     style={inputStyle}
//                                     onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
//                                     onBlur={(e) => { e.target.style.borderColor = cardBorder; e.target.style.boxShadow = 'none'; }}
//                                 />
//                                 {getBeneError.beneficiaryMobile && <span className="error text-danger" style={{ fontSize: fs(13) }}>Required</span>}
//                             </div>
//                             <div className="col-md-6">
//                                 <label style={{ fontWeight: 600, color: '#1A1A2E', marginBottom: 6, fontSize: fs(14) }}>Bank Name</label>
//                                 <Select
//                                     options={getBankListData}
//                                     className="normal-light w-100"
//                                     defaultValue={selectedOption}
//                                     classNamePrefix="select"
//                                     placeholder="Select Bank"
//                                     name="bankId"
//                                     onChange={(e) => onChangeBankIfscCode(e ? e.value : null)}
//                                     styles={{
//                                         control: (base) => ({
//                                             ...base,
//                                             borderRadius: '10px',
//                                             borderColor: cardBorder,
//                                             boxShadow: 'none',
//                                             '&:hover': { borderColor: primaryRed },
//                                             minHeight: '48px',
//                                             fontSize: fs(14),
//                                         })
//                                     }}
//                                 />
//                             </div>
//                             <div className="col-md-6">
//                                 <label style={{ fontWeight: 600, color: '#1A1A2E', marginBottom: 6, fontSize: fs(14) }}>IFSC Code *</label>
//                                 <div className="input-group" style={{ display: 'flex', alignItems: 'center' }}>
//                                     <input
//                                         type="text"
//                                         className="form-control"
//                                         name="ifscCode"
//                                         placeholder="Enter 11-character IFSC Code"
//                                         onChange={enterIfscCode}
//                                         value={getBeneData.ifscCode}
//                                         maxLength="11"
//                                         readOnly={isIfscEnable}
//                                         style={{ ...inputStyle, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
//                                         onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
//                                         onBlur={(e) => { e.target.style.borderColor = cardBorder; e.target.style.boxShadow = 'none'; }}
//                                     />
//                                     {getBeneData.ifscCode && getBeneError.ifscCodeVaild === 1 && (
//                                         <span className="input-group-text text-success" style={{ background: '#fff', border: `1px solid ${cardBorder}`, borderLeft: 'none', borderRadius: '0 10px 10px 0', padding: '0 16px', fontSize: fs(14), height: '48px', display: 'flex', alignItems: 'center' }}>✓ Valid</span>
//                                     )}
//                                     {getBeneData.ifscCode && getBeneError.ifscCodeVaild === 2 && (
//                                         <span className="input-group-text text-danger" style={{ background: '#fff', border: `1px solid ${cardBorder}`, borderLeft: 'none', borderRadius: '0 10px 10px 0', padding: '0 16px', fontSize: fs(14), height: '48px', display: 'flex', alignItems: 'center' }}>Invalid</span>
//                                     )}
//                                 </div>
//                                 {getBeneError.ifscCode && <span className="error text-danger" style={{ fontSize: fs(13) }}>Required</span>}
//                                 {getDataField.bankName && (
//                                     <div className="mt-2" style={{ background: '#F9FAFB', padding: '12px', borderRadius: '8px', border: `1px solid ${cardBorder}` }}>
//                                         <small style={{ fontSize: fs(12) }}><strong>Bank:</strong> {getDataField.bankName}</small><br />
//                                         <small style={{ fontSize: fs(12) }}><strong>Branch:</strong> {getDataField.branchAddress}</small>
//                                     </div>
//                                 )}
//                             </div>
//                             <div className="col-md-12">
//                                 <label style={{ fontWeight: 600, color: '#1A1A2E', marginBottom: 6, fontSize: fs(14) }}>Account Number *</label>
//                                 <div className="input-group" style={{ display: 'flex', alignItems: 'center' }}>
//                                     <input
//                                         type="text"
//                                         className="form-control"
//                                         name="accountNumber"
//                                         placeholder="Enter Account Number"
//                                         onChange={onChangeAddBene}
//                                         value={getBeneData.accountNumber}
//                                         maxLength="20"
//                                         onKeyDown={isNumber}
//                                         style={{ ...inputStyle, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
//                                         onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
//                                         onBlur={(e) => { e.target.style.borderColor = cardBorder; e.target.style.boxShadow = 'none'; }}
//                                     />
//                                     <button
//                                         type="button"
//                                         className="btn"
//                                         onClick={getBankNameFromAccountNumber}
//                                         style={{
//                                             background: primaryRed,
//                                             color: '#fff',
//                                             border: 'none',
//                                             borderRadius: '0 10px 10px 0',
//                                             padding: '0 20px',
//                                             fontWeight: 600,
//                                             transition: 'background 0.3s',
//                                             fontSize: fs(14),
//                                             height: '48px',
//                                             whiteSpace: 'nowrap',
//                                             display: 'inline-flex',
//                                             alignItems: 'center',
//                                             justifyContent: 'center',
//                                         }}
//                                         onMouseOver={(e) => e.target.style.background = '#B82228'}
//                                         onMouseOut={(e) => e.target.style.background = primaryRed}
//                                     >
//                                         Verify
//                                     </button>
//                                 </div>
//                                 {getBeneError.accountNumber && <span className="error text-danger" style={{ fontSize: fs(13) }}>Required</span>}
//                                 {getBeneData.beneBankName && (
//                                     <div className="mt-2" style={{ background: '#F9FAFB', padding: '12px', borderRadius: '8px', border: `1px solid ${cardBorder}` }}>
//                                         <small style={{ fontSize: fs(12) }}><strong>Account Holder:</strong> {getBeneData.beneBankName}</small>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                         <div style={{ marginTop: 24, display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
//                             <button
//                                 className="btn btn-default"
//                                 onClick={closeAddView}
//                                 style={{ borderRadius: '10px', padding: '0 28px', borderColor: '#d9d9d9', fontSize: fs(14), height: '48px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 className="btn btn-primary"
//                                 onClick={addBaneSave}
//                                 style={{
//                                     background: primaryRed,
//                                     border: 'none',
//                                     borderRadius: '10px',
//                                     padding: '0 32px',
//                                     fontWeight: 600,
//                                     color: '#fff',
//                                     fontSize: fs(14),
//                                     height: '48px',
//                                     display: 'inline-flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                 }}
//                             >
//                                 Save Beneficiary
//                             </button>
//                         </div>
//                     </div>
//                 );

//             case 'send':
//                 return (
//                     <div style={{
//                         background: '#fff',
//                         borderRadius: '20px',
//                         padding: '30px',
//                         boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
//                         border: `1px solid ${cardBorder}`,
//                     }}>
//                         <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
//                             <button
//                                 onClick={closeSendView}
//                                 style={{
//                                     background: 'transparent',
//                                     border: 'none',
//                                     color: primaryRed,
//                                     fontSize: fs(16),
//                                     fontWeight: 600,
//                                     cursor: 'pointer',
//                                     display: 'inline-flex',
//                                     alignItems: 'center',
//                                     gap: '6px',
//                                     padding: '8px 16px',
//                                     borderRadius: '8px',
//                                     transition: 'background 0.2s',
//                                     height: '44px',
//                                 }}
//                                 onMouseOver={(e) => e.currentTarget.style.background = '#f1f5f9'}
//                                 onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
//                             >
//                                 <ArrowLeftOutlined /> Back
//                             </button>
//                             <h5 style={{ margin: '0 0 0 16px', color: '#1A1A2E', fontWeight: 700, fontSize: fs(20) }}>
//                                 <i className="fa fa-credit-card" style={{ color: primaryRed, marginRight: 8 }} />
//                                 Confirm Transaction
//                             </h5>
//                         </div>

//                         <div className="row">
//                             <div className="col-md-12" style={{ background: '#f8fafc', padding: '16px 20px', borderRadius: '12px', marginBottom: 16 }}>
//                                 <div className="row">
//                                     <div className="col-md-6">
//                                         <div style={{ fontSize: fs(14) }}><strong>Beneficiary :</strong> {selectedSendRow.beneName}</div>
//                                         <div style={{ fontSize: fs(14) }}><strong>Bank :</strong> {selectedSendRow.bankName}</div>
//                                         <div style={{ fontSize: fs(14) }}><strong>IFSC:</strong> {selectedSendRow.ifscCode}</div>
//                                         <div style={{ fontSize: fs(14) }}><strong>Account:</strong> {selectedSendRow.accountNumber}</div>
//                                     </div>
//                                     <div className="col-md-6">
//                                         <div style={{ fontSize: fs(14) }}><strong>Amount to send:</strong> ₹{selectedSendRow.amount}</div>
//                                         {chargesData && (
//                                             <>
//                                                 <div style={{ fontSize: fs(14) }}>Service Charge: <strong>{chargesData.serviceAmount}</strong></div>
//                                                 <div style={{ fontSize: fs(14) }}>Commission: <strong>{chargesData.commissionAmount}</strong></div>
//                                                 <div style={{ fontSize: fs(14) }}>TDS: <strong>{chargesData.tdsAmount}</strong></div>
//                                             </>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>

//                             {chargesData && chargesData.instantOption && (
//                                 <div className="col-md-12 form-group">
//                                     <Checkbox onChange={onChangeCheckbox} checked={instantTransfer} style={{ fontSize: fs(14) }}>
//                                         Instant Transfer
//                                     </Checkbox>
//                                     <span className="mt-2" style={{ marginLeft: '8px', color: '#6B7280', fontSize: fs(13) }}>(Remaining Limit: {chargesData.instantLimit})</span>
//                                 </div>
//                             )}
//                             {instantTransferError && (
//                                 <p className="text-danger" style={{ fontSize: fs(14), marginTop: '-8px' }}>Instant Transfer limit exceeded: {chargesData.instantLimit}</p>
//                             )}

//                             <div className="col-md-12 form-group">
//                                 <label style={{ fontWeight: 600, color: '#1A1A2E', fontSize: fs(14) }}>Mode: </label>
//                                 <Radio.Group
//                                     defaultValue={2}
//                                     buttonStyle="solid"
//                                     onChange={onChangeChannel}
//                                     value={channel}
//                                     optionType="button"
//                                     style={{ marginLeft: '8px', fontSize: fs(14) }}
//                                 >
//                                     <Radio.Button value={1} style={{ fontSize: fs(14), height: '40px', lineHeight: '40px' }}>NEFT</Radio.Button>
//                                     <Radio.Button value={2} style={{ fontSize: fs(14), height: '40px', lineHeight: '40px' }}>IMPS</Radio.Button>
//                                 </Radio.Group>
//                             </div>

//                             <div className="col-md-12 form-group">
//                                 <label style={{ fontWeight: 600, color: '#1A1A2E', fontSize: fs(14) }}>Confirm Amount (re‑type exactly): </label>
//                                 <input
//                                     type="text"
//                                     name="amount"
//                                     className="form-control"
//                                     value={sendMoneyAmount}
//                                     onChange={handleAmount}
//                                     onKeyDown={isNumber}
//                                     maxLength="6"
//                                     placeholder="Re‑enter amount to confirm"
//                                     style={inputStyle}
//                                     onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
//                                     onBlur={(e) => { e.target.style.borderColor = cardBorder; e.target.style.boxShadow = 'none'; }}
//                                 />
//                                 {sendMoneyAmount && parseFloat(sendMoneyAmount) !== parseFloat(selectedSendRow.amount) && (
//                                     <span className="text-danger" style={{ fontSize: fs(13) }}>Amount does not match the original</span>
//                                 )}
//                             </div>
//                         </div>
//                         <div style={{ marginTop: 24, display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
//                             <button
//                                 className="btn btn-default"
//                                 onClick={closeSendView}
//                                 style={{ borderRadius: '10px', padding: '0 28px', borderColor: '#d9d9d9', fontSize: fs(14), height: '48px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 className="btn btn-primary"
//                                 onClick={() => handleSaveSend(selectedSendRow)}
//                                 style={{
//                                     background: primaryRed,
//                                     border: 'none',
//                                     borderRadius: '10px',
//                                     padding: '0 32px',
//                                     fontWeight: 600,
//                                     color: '#fff',
//                                     fontSize: fs(14),
//                                     height: '48px',
//                                     display: 'inline-flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                 }}
//                             >
//                                 Confirm & Proceed
//                             </button>
//                         </div>
//                     </div>
//                 );

//             case 'otp':
//                 return (
//                     <div style={{
//                         background: '#fff',
//                         borderRadius: '20px',
//                         padding: '30px',
//                         maxWidth: '600px',
//                         margin: '0 auto',
//                         boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
//                         border: `1px solid ${cardBorder}`,
//                     }}>
//                         <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
//                             <button
//                                 onClick={confirmCancelTransaction}
//                                 style={{
//                                     background: 'transparent',
//                                     border: 'none',
//                                     color: primaryRed,
//                                     fontSize: fs(16),
//                                     fontWeight: 600,
//                                     cursor: 'pointer',
//                                     display: 'inline-flex',
//                                     alignItems: 'center',
//                                     gap: '6px',
//                                     padding: '8px 16px',
//                                     borderRadius: '8px',
//                                     transition: 'background 0.2s',
//                                     height: '44px',
//                                 }}
//                                 onMouseOver={(e) => e.currentTarget.style.background = '#f1f5f9'}
//                                 onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
//                             >
//                                 <ArrowLeftOutlined /> Cancel
//                             </button>
//                             <h5 style={{ margin: '0 0 0 16px', color: '#1A1A2E', fontWeight: 700, fontSize: fs(20) }}>
//                                 <i className="fa fa-shield" style={{ color: primaryRed, marginRight: 8 }} />
//                                 Transaction OTP
//                             </h5>
//                         </div>

//                         <div style={{ background: '#F9FAFB', padding: '12px 16px', borderRadius: '10px', marginBottom: '16px', fontSize: fs(14) }}>
//                             <div><strong>Transaction:</strong> {transactionId}</div>
//                             <div><strong>Amount:</strong> ₹{transactionSlab && transactionSlab[transactionIndex]?.amount}</div>
//                             <div><strong>Account:</strong> {selectedSendRow?.accountNumber}</div>
//                             <div><strong>Beneficiary:</strong> {selectedSendRow?.beneName}</div>
//                         </div>
//                         <div className="form-group">
//                             <label style={{ fontWeight: 600, color: '#1A1A2E', fontSize: fs(14), marginBottom: 6 }}>OTP Code</label>
//                             <input
//                                 type="text"
//                                 className="form-control"
//                                 name="otpCode"
//                                 placeholder="Enter 4-digit OTP"
//                                 onChange={(e) => onChangeOtpValue(e.target.value)}
//                                 value={otpCode}
//                                 maxLength="4"
//                                 onKeyDown={isNumber}
//                                 style={inputStyle}
//                                 onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
//                                 onBlur={(e) => { e.target.style.borderColor = cardBorder; e.target.style.boxShadow = 'none'; }}
//                             />
//                             <small className="text-muted" style={{ fontSize: fs(12) }}>Enter the 4-digit OTP sent to your registered mobile</small>
//                         </div>
//                         <div className="form-group pt-2 text-right">
//                             <button
//                                 type="button"
//                                 className="btn btn-default mr-2"
//                                 onClick={confirmCancelTransaction}
//                                 style={{ borderRadius: '10px', padding: '0 24px', borderColor: '#d9d9d9', color: '#6B7280', fontSize: fs(14), height: '48px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 type="button"
//                                 className="btn"
//                                 onClick={handlePayment}
//                                 style={{
//                                     background: `linear-gradient(135deg, ${primaryRed}, #E8454B)`,
//                                     color: '#fff',
//                                     border: 'none',
//                                     borderRadius: '10px',
//                                     padding: '0 32px',
//                                     fontWeight: 600,
//                                     boxShadow: '0 4px 12px rgba(201,38,44,0.25)',
//                                     transition: 'all 0.3s ease',
//                                     fontSize: fs(14),
//                                     height: '48px',
//                                     display: 'inline-flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                 }}
//                                 onMouseOver={(e) => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 6px 20px rgba(201,38,44,0.35)'; }}
//                                 onMouseOut={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 4px 12px rgba(201,38,44,0.25)'; }}
//                             >
//                                 Submit
//                             </button>
//                         </div>
//                     </div>
//                 );

//             case 'otpBatch':
//                 return (
//                     <div style={{
//                         background: '#fff',
//                         borderRadius: '20px',
//                         padding: '30px',
//                         boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
//                         border: `1px solid ${cardBorder}`,
//                     }}>
//                         <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
//                             <button
//                                 onClick={confirmCancelTransaction}
//                                 style={{
//                                     background: 'transparent',
//                                     border: 'none',
//                                     color: primaryRed,
//                                     fontSize: fs(16),
//                                     fontWeight: 600,
//                                     cursor: 'pointer',
//                                     display: 'inline-flex',
//                                     alignItems: 'center',
//                                     gap: '6px',
//                                     padding: '8px 16px',
//                                     borderRadius: '8px',
//                                     transition: 'background 0.2s',
//                                     height: '44px',
//                                 }}
//                                 onMouseOver={(e) => e.currentTarget.style.background = '#f1f5f9'}
//                                 onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
//                             >
//                                 <ArrowLeftOutlined /> Cancel
//                             </button>
//                             <h5 style={{ margin: '0 0 0 16px', color: '#1A1A2E', fontWeight: 700, fontSize: fs(20) }}>
//                                 <i className="fa fa-shield" style={{ color: primaryRed, marginRight: 8 }} />
//                                 Transaction OTP (Batch)
//                             </h5>
//                         </div>

//                         <div className="col-md-12" style={{ marginBottom: 16 }}>
//                             <div style={{ background: '#F9FAFB', padding: '12px 16px', borderRadius: '10px', fontSize: fs(14) }}>
//                                 <strong>Total amount:</strong> ₹{selectedSendRow.amount}
//                             </div>
//                             <div style={{ background: '#F9FAFB', padding: '12px 16px', borderRadius: '10px', fontSize: fs(14), marginTop: 8 }}>
//                                 <div><strong>Account:</strong> {selectedSendRow?.accountNumber}</div>
//                                 <div><strong>Beneficiary:</strong> {selectedSendRow?.beneName}</div>
//                             </div>
//                         </div>

//                         <div className="form-group pt-3 pb-3" style={{ maxHeight: '400px', overflowY: 'auto' }}>
//                             {transactionSlab?.map((item) => (
//                                 <div
//                                     key={item.transactionId}
//                                     className="border-bottom border-light-gray col-md-12 py-2"
//                                     style={{
//                                         borderBottom: `1px solid ${cardBorder}`,
//                                         padding: '12px 0',
//                                         opacity: item.transactionId !== transactionId ? 0.7 : 1,
//                                         backgroundColor: item.transactionId !== transactionId ? 'rgba(0,0,0,0.02)' : 'transparent',
//                                         fontSize: fs(14),
//                                     }}
//                                 >
//                                     <div className="row align-items-center">
//                                         <div className="col-md-3">
//                                             <p style={{ color: '#1A1A2E', fontWeight: 600, margin: 0 }}>₹{item.amount}</p>
//                                             <p style={{ fontSize: fs(12), color: '#6B7280', margin: 0 }}>Id: {item.transactionId}</p>
//                                         </div>
//                                         <div className="col-md-2">
//                                             {item?.statusCode?.toString() === '0' && (
//                                                 <span className="badge badge-pill badge-success" style={{ background: primaryGreen, color: '#fff', padding: '4px 10px', borderRadius: '20px', fontSize: fs(12) }}>{item?.statusText}</span>
//                                             )}
//                                             {item?.statusCode?.toString() === '1' && (
//                                                 <span className="badge badge-pill badge-danger" style={{ background: '#EF4444', color: '#fff', padding: '4px 10px', borderRadius: '20px', fontSize: fs(12) }}>{item?.statusText}</span>
//                                             )}
//                                             {!item?.statusCode && (
//                                                 <span className="badge badge-pill badge-warning" style={{ background: '#FBBF24', color: '#1A1A2E', padding: '4px 10px', borderRadius: '20px', fontSize: fs(12) }}>Pending</span>
//                                             )}
//                                         </div>
//                                         <div className="col-md-3">
//                                             {item.transactionId === transactionId && item?.otpSent && (
//                                                 <div className="input-group">
//                                                     <input
//                                                         type="text"
//                                                         className="form-control"
//                                                         name="otpCode"
//                                                         placeholder="4-digit OTP"
//                                                         onChange={(e) => onChangeOtpValue(e.target.value)}
//                                                         value={otpCode}
//                                                         maxLength="4"
//                                                         onKeyDown={isNumber}
//                                                         style={{
//                                                             ...inputStyle,
//                                                             height: '40px',
//                                                             fontSize: fs(14),
//                                                         }}
//                                                         onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
//                                                         onBlur={(e) => { e.target.style.borderColor = cardBorder; e.target.style.boxShadow = 'none'; }}
//                                                     />
//                                                 </div>
//                                             )}
//                                         </div>
//                                         {item.transactionId === transactionId && (
//                                             <>
//                                                 <div className="col-md-2">
//                                                     {item?.otpSent ? (
//                                                         <span style={{ color: primaryGreen, fontWeight: 600, fontSize: fs(13) }}>OTP Sent</span>
//                                                     ) : !isOTPSendingInProgress ? (
//                                                         <button
//                                                             type="button"
//                                                             className="btn"
//                                                             onClick={() => generateTransaction(item)}
//                                                             disabled={isOTPSendingInProgress}
//                                                             style={{
//                                                                 background: `linear-gradient(135deg, ${primaryRed}, #E8454B)`,
//                                                                 color: '#fff',
//                                                                 border: 'none',
//                                                                 borderRadius: '8px',
//                                                                 padding: '0 16px',
//                                                                 fontWeight: 600,
//                                                                 transition: 'all 0.3s ease',
//                                                                 fontSize: fs(12),
//                                                                 height: '36px',
//                                                                 display: 'inline-flex',
//                                                                 alignItems: 'center',
//                                                                 justifyContent: 'center',
//                                                             }}
//                                                             onMouseOver={(e) => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 4px 12px rgba(201,38,44,0.3)'; }}
//                                                             onMouseOut={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = 'none'; }}
//                                                         >
//                                                             Send OTP
//                                                         </button>
//                                                     ) : (
//                                                         <button type="button" className="btn btn-secondary" disabled style={{ borderRadius: '8px', padding: '0 16px', fontSize: fs(12), height: '36px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
//                                                             <i className="fa-solid fa-spinner fa-spin mr-2"></i> Sending
//                                                         </button>
//                                                     )}
//                                                 </div>
//                                                 <div className="col-md-2">
//                                                     {!isOTPSubmitInProgress ? (
//                                                         <button
//                                                             type="button"
//                                                             className="btn"
//                                                             onClick={handlePayment}
//                                                             disabled={!item?.otpSent}
//                                                             style={{
//                                                                 background: primaryGreen,
//                                                                 color: '#fff',
//                                                                 border: 'none',
//                                                                 borderRadius: '8px',
//                                                                 padding: '0 16px',
//                                                                 fontWeight: 600,
//                                                                 transition: 'all 0.3s ease',
//                                                                 fontSize: fs(12),
//                                                                 height: '36px',
//                                                                 display: 'inline-flex',
//                                                                 alignItems: 'center',
//                                                                 justifyContent: 'center',
//                                                             }}
//                                                             onMouseOver={(e) => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 4px 12px rgba(2,166,80,0.3)'; }}
//                                                             onMouseOut={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = 'none'; }}
//                                                         >
//                                                             Submit
//                                                         </button>
//                                                     ) : (
//                                                         <button type="button" className="btn btn-secondary" disabled style={{ borderRadius: '8px', padding: '0 16px', fontSize: fs(12), height: '36px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
//                                                             <i className="fa-solid fa-spinner fa-spin mr-2"></i> Wait...
//                                                         </button>
//                                                     )}
//                                                 </div>
//                                             </>
//                                         )}
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                         <div className="form-group pt-2 text-right">
//                             <button
//                                 type="button"
//                                 className="btn btn-default"
//                                 onClick={confirmCancelTransaction}
//                                 style={{ borderRadius: '10px', padding: '0 24px', borderColor: '#d9d9d9', color: '#6B7280', fontSize: fs(14), height: '48px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
//                             >
//                                 Cancel
//                             </button>
//                         </div>
//                     </div>
//                 );

//             default:
//                 return null;
//         }
//     };

//     // ----- Render -----
//     return (
//         <section style={{
//             background: 'linear-gradient(160deg, #FFFBEB 0%, #FFF8F5 25%, #FFFBEB 50%, #F8F9FF 75%, #FFFBEB 100%)',
//             padding: '20px 0 40px',
//             minHeight: '100vh',
//             position: 'relative',
//             overflow: 'hidden',
//             fontSize: fs(14),
//         }}>
//             <div style={{ position: 'absolute', top: -80, right: -80, width: 350, height: 350, background: 'radial-gradient(circle, rgba(255,221,9,0.15) 0%, transparent 70%)', borderRadius: '50%' }} />
//             <div style={{ position: 'absolute', bottom: -40, left: -40, width: 250, height: 250, background: 'radial-gradient(circle, rgba(201,38,44,0.08) 0%, transparent 70%)', borderRadius: '50%' }} />

//             <div className="container" style={{ maxWidth: '1400px', margin: '0 auto', position: 'relative', zIndex: 2, padding: '0 15px' }}>
//                 {renderView()}
//             </div>

//             <ToastContainer position="top-center" autoClose={5000} limit={2} />

//             {/* ----- Modals (Payment Status, Import, Popup) ----- */}
//             {isPaymentStatusModal && (
//                 <Modal
//                     title={<span style={{ color: '#1A1A2E', fontWeight: 700, fontSize: fs(16) }}><i className="fa fa-info-circle" style={{ color: primaryRed, marginRight: '8px' }} /> Payment Status</span>}
//                     width={600}
//                     open={isPaymentStatusModal}
//                     onOk={() => generateNextTransaction()}
//                     onCancel={confirmCancelTransaction}
//                     okText={(transactionIndex === transactionLength) ? "Print Invoice" : "Continue"}
//                     cancelText="Cancel"
//                     maskClosable={false}
//                     keyboard={false}
//                     destroyOnClose
//                     bodyStyle={{ padding: '24px 30px' }}
//                     style={{ borderRadius: '16px' }}
//                     okButtonProps={{
//                         style: {
//                             background: primaryRed,
//                             borderColor: primaryRed,
//                             borderRadius: '8px',
//                             fontWeight: 600,
//                         }
//                     }}
//                     cancelButtonProps={{
//                         style: {
//                             borderRadius: '8px',
//                             borderColor: '#d9d9d9',
//                             color: '#6B7280',
//                         }
//                     }}
//                 >
//                     <div className="form-group">
//                         <h5 className="text-center mt-3" style={{ fontSize: fs(18) }}>Transaction : {transactionId}</h5>
//                         <div className="text-center my-3">
//                             {transactionStatus === "1" && (
//                                 <>
//                                     <div style={{ borderRadius: 200, height: 140, width: 140, background: '#FFE6E6', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                                         <span style={{ color: "#E60000", fontSize: '72px', fontWeight: '300' }}>✕</span>
//                                     </div>
//                                     <h1 style={{ color: '#E60000', marginTop: '12px', fontSize: fs(24) }}>{transactionStatusText}</h1>
//                                 </>
//                             )}
//                             {transactionStatus === "0" && (
//                                 <>
//                                     <div style={{ borderRadius: 200, height: 140, width: 140, background: '#F0FDF4', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                                         <span style={{ color: primaryGreen, fontSize: '72px', fontWeight: '300' }}>✓</span>
//                                     </div>
//                                     <h1 style={{ color: primaryGreen, marginTop: '12px', fontSize: fs(24) }}>{transactionStatusText}</h1>
//                                 </>
//                             )}
//                             {(transactionStatus !== "0" && transactionStatus !== "1") && (
//                                 <>
//                                     <div style={{ borderRadius: 200, height: 140, width: 140, background: '#FEF3C7', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                                         <i className="fa fa-clock-o" style={{ fontSize: '64px', color: '#D97706' }} aria-hidden="true"></i>
//                                     </div>
//                                     <h1 style={{ color: '#D97706', marginTop: '12px', fontSize: fs(24) }}>{transactionStatusText || 'Pending'}</h1>
//                                 </>
//                             )}
//                         </div>
//                     </div>
//                 </Modal>
//             )}

//             {/* Bank Selection Popup */}
//             {showPopup && (
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     background: 'rgba(0,0,0,0.5)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     zIndex: 1000,
//                     animation: 'fadeIn 0.2s ease',
//                 }}>
//                     <div style={{
//                         background: '#fff',
//                         borderRadius: '20px',
//                         padding: '30px',
//                         width: '400px',
//                         maxWidth: '90%',
//                         boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
//                     }}>
//                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
//                             <h3 style={{ margin: 0, color: '#1A1A2E', fontWeight: 700, fontSize: fs(20) }}>Verify Beneficiary</h3>
//                             <span
//                                 onClick={() => setShowPopup(false)}
//                                 style={{
//                                     fontSize: fs(28),
//                                     cursor: 'pointer',
//                                     color: '#6B7280',
//                                     lineHeight: 1,
//                                 }}
//                             >
//                                 ×
//                             </span>
//                         </div>
//                         <p style={{ color: '#6B7280', marginBottom: '20px', fontSize: fs(14) }}>Choose bank to proceed with verification</p>
//                         <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
//                             <button
//                                 className="btn"
//                                 onClick={() => {
//                                     setShowPopup(false);
//                                     getName(selectedRow, false);
//                                 }}
//                                 style={{
//                                     background: primaryRed,
//                                     color: '#fff',
//                                     border: 'none',
//                                     borderRadius: '10px',
//                                     padding: '0 28px',
//                                     fontWeight: 600,
//                                     transition: 'all 0.3s ease',
//                                     fontSize: fs(14),
//                                     height: '48px',
//                                     display: 'inline-flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                 }}
//                                 onMouseOver={(e) => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 4px 12px rgba(201,38,44,0.3)'; }}
//                                 onMouseOut={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = 'none'; }}
//                             >
//                                 Bank 1
//                             </button>
//                             <button
//                                 className="btn"
//                                 onClick={() => {
//                                     setShowPopup(false);
//                                     getName(selectedRow, true);
//                                 }}
//                                 style={{
//                                     background: primaryOrange,
//                                     color: '#fff',
//                                     border: 'none',
//                                     borderRadius: '10px',
//                                     padding: '0 28px',
//                                     fontWeight: 600,
//                                     transition: 'all 0.3s ease',
//                                     fontSize: fs(14),
//                                     height: '48px',
//                                     display: 'inline-flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                 }}
//                                 onMouseOver={(e) => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 4px 12px rgba(255,140,0,0.3)'; }}
//                                 onMouseOut={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = 'none'; }}
//                             >
//                                 Bank 2
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Import Modal */}
//             {importModal && (
//                 <Modal
//                     open={importModal}
//                     width={1000}
//                     footer={false}
//                     onCancel={() => setImportModal(false)}
//                     closable={true}
//                     maskClosable={false}
//                     keyboard={false}
//                     destroyOnClose
//                     bodyStyle={{ padding: '20px' }}
//                     style={{ borderRadius: '16px' }}
//                 >
//                     <ImportBaneficiary
//                         mode="DMT2.0"
//                         customerMobile={saveCustomerMobile}
//                         addBaneficiary={importBaneficiarySave}
//                         onClose={() => setImportModal(false)}
//                     />
//                 </Modal>
//             )}

//             <style>{`
//                 @keyframes fadeIn {
//                     from { opacity: 0; }
//                     to { opacity: 1; }
//                 }
//             `}</style>
//         </section>
//     );
// }

// export default BeneficiaryList;